// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"88ee86f7","133":"10e1309e","359":"d1988797","480":"3f1fecdc","804":"b9a89006"}[chunkId] + ".chunk.js";
};